import { useEffect, useState } from "react";

/**
 * SplashScreen — full-screen white intro with the Boscage deer logo.
 * Shown once per browser session (uses sessionStorage so re-opening the
 * tab / new session triggers it again, refreshes within the session do not).
 * Duration: 1 second, fades out gracefully.
 */
const STORAGE_KEY = "boscage_splash_shown";
// Boscage brand deer silhouette mark (updated).
const DEER_LOGO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_premium-jackets-6/artifacts/40ul5rf3_Your%20paragraph%20text%20%281%29.png";

export default function SplashScreen() {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.sessionStorage.getItem(STORAGE_KEY)) return;

    setVisible(true);
    const leaveTimer = setTimeout(() => setLeaving(true), 900);
    const removeTimer = setTimeout(() => {
      setVisible(false);
      window.sessionStorage.setItem(STORAGE_KEY, "1");
    }, 1350);

    return () => {
      clearTimeout(leaveTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[10000] bg-white flex items-center justify-center transition-opacity duration-500 ${
        leaving ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
      aria-hidden="true"
    >
      <img
        src={DEER_LOGO}
        alt="Boscage"
        data-testid="splash-logo"
        className="w-[140px] h-[140px] md:w-[180px] md:h-[180px] object-contain splash-logo-in"
      />
    </div>
  );
}
